import ko from "knockout";
import {
    statisticEpisodeWatch,
    statisticWatchStart,
    statisticWatchStop
} from "api";
import {getStreamDay} from "./tools";

export default function ($app) {
	let cometChannel;
	let currentWatch = null;

    this.setCometChannel = (channel) => {
        cometChannel = channel;

        return this;
    };

    this.getCometChannel = () => cometChannel;

    function createWatch(stream, episode, timeStart, streamDay) {
        const params = {
            episodeId: episode?.id(),
            cometChannel,
            timeStart,
            streamDay,
            offset: stream.isRecorded() ? stream?.offset() : 0,
        };
        const startPromise = statisticWatchStart(stream.id(), params).then(({id}) => id);

		return (timeStop) => {
            return startPromise.then((watchId) => (
                statisticWatchStop(watchId, {timeStop})
            ));
		};
	}

	const sendWatchStart = (stream, episode, time, streamDay) => {
		currentWatch = createWatch(stream, episode, time, streamDay);
	};
	const sendWatchStop = (time) => {
		if(null === currentWatch) {
            return;
        }

        currentWatch(time);
        currentWatch = null;
	};

    const subscribeStreamWatch = () => {
        const $player = $app.require('player');
        let lastTime = null;
        let lastSource = null;

        ko.computed(() => {
            const currentStream = $app.currentStream();
            const currentStreamDay = $app.currentStreamDay();
            let currentTime = $player.currentTime();
            let currentSource = currentStream;
            let episode = null;

            if (currentStream && currentStream.isEpisodeRecorded()) {
                currentSource = $app.currentEpisode();
                episode = $app.currentEpisode();
            }

            if (currentStream && !currentStream.dvr()) {
                currentTime = $player.duration();
            }

            if (
                currentStream
                && currentStreamDay > 0
                && currentStream.archiveStatus() === 'none'
            ) {
                currentTime += currentStream.broadcastSession().reduce((time, session) => {
                    if (getStreamDay(currentStream.timeStart(), session.timeStart()) < currentStreamDay) {
                        return time + (session.timeStop() - session.timeStart());
                    }

                    return time;
                }, 0);
            }

            if (lastSource !== currentSource) {
                if (lastSource) {
                    sendWatchStop(lastTime);
                }

                if (currentSource) {
                    sendWatchStart(currentStream, episode, currentTime, currentStreamDay);
                }

                lastSource = currentSource;
            } else if (currentSource && (currentTime < lastTime || currentTime > lastTime + 10)) {
                sendWatchStop(lastTime);
                sendWatchStart(currentStream, episode, currentTime, currentStreamDay);
            }

            lastTime = currentTime;

            return () => {};
        }).extend({throttle: 100});
    }

	$app.on('start', () => {
        subscribeStreamWatch();

		// $app.require('player')
		// 	.on('currentTime', (currentTime) => {
		// 		if(null === lastTime && lastStream) {
		// 			sendWatchStart(lastStream, currentTime);
		// 		} else if(currentTime < lastTime || currentTime > lastTime + 10) {
		// 			sendWatchStop(lastTime);
		// 			if(lastStream) {
		// 				sendWatchStart(lastStream, currentTime);
		// 			}
		// 		}
        //
		// 		lastTime = currentTime;
		// 	})
		// ;
        //
		// $app
		// 	.on('currentStream', (currentStream) => {
		// 		if(lastTime && lastStream && currentWatch) {
		// 			sendWatchStop(lastTime);
		// 		}
        //
		// 		lastStream = currentStream;
		// 		lastTime = null;
		// 	})
		// ;

		$app.currentEpisode.subscribe(currentEpisode => {
			if(currentEpisode && currentEpisode.id) {
				statisticEpisodeWatch(currentEpisode.id());
			}
		});
	});
}
